import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { BASE_WEIGHT_FACTOR, WEIGHT_REDUCE_FACTOR, FORCE_REPLACE_WEIGHT, BEST_THAN_CURRENT_WEIGHT, CURRENT_WORSE_THAN_PREV_WEIGHT } from './constants';
var prevDomainConfig = {
  domain: '',
  weight: 0
};
/**
 *
 *  {
 *    'bybit.com': [200, 200, 300],
 *    'byapis.com': [100, 300, 400],
 *    'bynbe.com': [300, 400, 400],
 *  }
 *
 * @param {array} list The status list
 */
// module.exports = function weightCalculation (list = []) {
export default function weightCalculation() {
  var rttMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var weightMap = Object.keys(rttMap).reduce(function (prev, cur) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur, rttMap[cur].reduce(function (prevResult, curRTT) {
      return {
        factor: prevResult.factor - WEIGHT_REDUCE_FACTOR,
        weight: prevResult.weight + curRTT * prevResult.factor
      };
    }, {
      factor: BASE_WEIGHT_FACTOR,
      weight: 0
    }).weight));
  }, {});
  var bestDomainConfig = Object.keys(weightMap).reduce(function (prev, cur) {
    if (!prev.domain) return {
      domain: cur,
      weight: weightMap[cur]
    };
    if (prev.weight > weightMap[cur]) return {
      domain: cur,
      weight: weightMap[cur]
    };
    return prev;
  }, {});

  /* eslint-disable */
  if (typeof window !== 'undefined' && window && window.$_router_info) {
    console.log('rttMap = ', rttMap);
    console.log('weightMap = ', weightMap);
    console.log('bestDomainConfig = ', bestDomainConfig.domain);
  }
  /* eslint-enable */

  if (!prevDomainConfig.domain) {
    prevDomainConfig = bestDomainConfig;
    return bestDomainConfig;
  }
  if (prevDomainConfig.domain && prevDomainConfig.domain !== bestDomainConfig.domain) {
    if (prevDomainConfig.weight - bestDomainConfig.weight > FORCE_REPLACE_WEIGHT) {
      prevDomainConfig = bestDomainConfig;
      return bestDomainConfig;
    }
    var selectedDomainWeight = weightMap[prevDomainConfig.domain];
    if (selectedDomainWeight - bestDomainConfig.weight > BEST_THAN_CURRENT_WEIGHT) {
      prevDomainConfig = bestDomainConfig;
      return bestDomainConfig;
    }
    if (selectedDomainWeight - prevDomainConfig.weight > CURRENT_WORSE_THAN_PREV_WEIGHT) {
      prevDomainConfig = bestDomainConfig;
      return bestDomainConfig;
    }
    return prevDomainConfig;
  }
  if (prevDomainConfig.weight > bestDomainConfig.weight) {
    prevDomainConfig = bestDomainConfig;
  }
  return prevDomainConfig;
}